import { ImageFitType, ImageType } from './constants';

const createBaseParams = (options: SourceBuilderOptions) => {
  let baseParams = '&auto=compress,format';

  const isAspectRatio = options.type === ImageType.aspectRatio;

  if (isAspectRatio) {
    baseParams += `&ar=${options.aspectRatio}&fit=${options.fit}`;
  }

  if (isAspectRatio && options.fit === ImageFitType.fill) {
    baseParams += `&fill=blur`;
  }

  return baseParams;
};

type SourceBuilderOptions = {
  src: string;
} & ({ type: ImageType.aspectRatio; aspectRatio: string; fit: ImageFitType } | { type: ImageType.fillContainer });

export const makeSourceBuilder =
  (options: SourceBuilderOptions) =>
  ({ width, withoutRetina }: { width: number; withoutRetina?: boolean }) => {
    const baseParams = createBaseParams(options);

    if (withoutRetina) {
      return `${options.src}?w=${width}${baseParams}`;
    }

    const dprConfig = [
      ['1', '45'], // default quality when using auto=compress
      ['2', '30'],
      ['3', '20'],
    ];

    const srcString = dprConfig
      .map(
        ([dprFactor, quality]) => `${options.src}?w=${width}&dpr=${dprFactor}&q=${quality}${baseParams} ${dprFactor}x`,
      )
      .join(', ');

    return srcString;
  };
